import { render } from "./Start.vue?vue&type=template&id=6befadf7&scoped=true"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import "./Start.vue?vue&type=style&index=0&id=6befadf7&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6befadf7"]])

export default __exports__